RivalIQ.apps.Reports.module('widgets', function (widgets, App, Backbone, Marionette, $, _, s) {

    'use strict';

    const Widget = RivalIQ.apps.Dashboard.models.Widget;
    const ExportOptionTooltipItem = Marionette.ItemView.extend({
        tagName: 'li',
        template: function (data) {

            const template = _.template('<%- name %>');
            return template(data);
        }
    });

    widgets.ExportOption = Marionette.CompositeView.mixin({
        template: '#reportsExportOptionTemplate',
        tagName: 'tr',
        exportLimit: 15,

        ui: {
            emailBtn: '[data-action="email"]',
            scheduleBtn: '[data-action="scheduled"]',
            downloadBtn: '[data-action="download"]'
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        behaviors: {
            Information: {
                selector: '.x-popover-content'
            }
        },

        events: {
            'click @ui.emailBtn': 'showEmailModal',
            'click @ui.scheduleBtn': 'showScheduleModal',
            'click @ui.downloadBtn': 'download'
        },

        childViewContainer: 'ul.small',
        childView: ExportOptionTooltipItem,

        download: function () {
            const me = this;
            const curation = me.getReportCuration();
            RivalIQ.export.download(curation.getReportFormat(), curation);
        },

        exceedsCompanyLimit: function () {
            const me = this;

            const curation = me.getReportCuration();
            if (curation.getReportFormat() === RivalIQ.export.format.CSV) {
                return false;
            }

            const companies = RivalIQ.state.landscape.getCompaniesByCompanySet(me.getProp('companySetDescriptor'));

            return (_.size(companies) > me.getOption('exportLimit'));
        },

        showScheduleModal: function () {
            const me = this;

            const options = {};

            if (me.exceedsCompanyLimit()) {
                options.warning = {
                    companyLimit: me.getOption('exportLimit')
                };
            }

            const curation = me.getReportCuration();
            RivalIQ.export.schedule(curation, options);
        },

        showEmailModal: function () {
            const me = this;

            const options = {};

            if (me.exceedsCompanyLimit()) {
                options.warning = {
                    companyLimit: me.getOption('exportLimit')
                };
            }

            const curation = me.getReportCuration();
            RivalIQ.export.email(curation.getReportFormat(), curation, options);
        },

        /*
         * Update report curation state before generating the export
         */
        getReportCuration: function () {
            const me = this;
            const props = _.extend(me._curation.configuration.getProps(), me.dashboardModel.getProps());
            me._curation.resetPropHash('configurationProps', props, {
                silent: true
            });
            return me._curation;
        },

        initialize: function () {
            const me = this;
            me.buildReportCuration();
        },

        buildReportCuration: function () {
            const me = this;
            const router = me.dashboardModel.curation.router;

            const curation = new App.curations.Report(router, {
                curation_id: RivalIQ.enums.curation.REPORT
            });

            curation.setConfiguration(me.model);
            curation.setPropHash('globalProps', {
                reportId: me.model.id
            });

            me._curation = curation;
        },

        templateHelpers: function () {
            const me = this;

            let actions = me.getReportCuration().getExportTypes();

            actions = _.map(actions, function (action) {
                return {
                    type: action,
                    title: (action === RivalIQ.export.type.SCHEDULE ? 'Schedule' : action)
                };
            });

            return {
                s: s,
                disable: false, // TODO remove, no existing reports are ever disabled
                isCsvReport: Boolean(me.model.get('csvExportType')),
                actions: actions
            };
        },

        serializeData: function () {
            const me = this;
            return _.extend({}, me.model.toJSON(), me.model.getProps());
        },

        filter: function (child) {

            const omit = child.get('omit');
            return !(_.isFunction(omit) ? omit.call(child) : omit);
        }
    });

    const ReportConfigurations = Backbone.Collection.extend({
        comparator: function (child) {
            return child.get('index');
        }
    });

    const Reports = widgets.Reports = RivalIQ.views.CollectionView.mixin({
        template: '#reportsPowerPointExportTemplate',
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },
        childView: widgets.ExportOption,
        tagName: 'table',
        className: 'table table-fixed',

        filter: function (config) {
            const me = this;
            return RivalIQ.props.channelAccess(me.getProps(), config.getProps().source);
        },

        childViewOptions: function (model) {
            const me = this;

            const description = model.get('description');
            const items = _.result(description, 'items');

            return {
                dashboardModel: me.dashboardModel,
                collection: new Backbone.Collection(
                    _.map(items, function (item) {
                        return (_.isString(item) ? {
                            name: item
                        } : item);
                    })
                )
            };
        },

        // NOTE we fetch report definitions here so we have already cached the
        // configurations for each report curation
        loadData: function (done) {
            const me = this;
            RivalIQ.data.reportConfigurations.fetch().done(function (definitions) {
                me.collection = new ReportConfigurations(definitions.filter(function (definition) {
                    return definition.get('type') === me.getProp('reportType');
                }));

                done();
            });
        },

        onRenderLoaded: function () {
            const me = this;

            // if there are no visible reports, hide the whole panel.
            const hasItem = me.collection.find(config => me.filter(config));
            if (!hasItem) {
                me.$el.parents('.panel').hide();
            }
        }
    });

    const types = {
        channel: {
            title: RivalIQ.strings.channel_reports_title,
            description: RivalIQ.strings.channel_reports_description
        },
        cross_channel: {
            title: RivalIQ.strings.combination_reports_title,
            description: RivalIQ.strings.combination_reports_description
        },
        csv_public: {
            title: RivalIQ.strings.csv_public_reports_title,
            description: RivalIQ.strings.csv_public_reports_description
        },
        csv_private: {
            title: RivalIQ.strings.csv_private_reports_title,
            description: RivalIQ.strings.csv_private_reports_description
        }
    };

    const ReportWidget = Widget.extend({
        title: function () {
            const me = this;
            const plan = RivalIQ.state.account.get('plan');
            if (plan.has_multi_handle_private_basic && me.getProp('reportType') === 'csv_private') {
                return RivalIQ.strings.csv_private_multi_handle_reports_title;
            } else {
                return types[me.getProp('reportType')].title;
            }
        },
        description: function () {
            const me = this;
            return types[me.getProp('reportType')].description;
        },
        view: Reports,
        exportFormats: [],
        hasFooter: _.constant(false)
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.REPORT_PICKER, ReportWidget);

}, window.s);
